import React from 'react'
import PropTypes from 'prop-types'
import * as my from './MyForm'

export const TextInput = ({
	className = '',
	inputClassName = '',
	inputRef = false,
	inline = false,
	inlineExtended = false,
	label = '',
	labelClassName,
	name = '',
	type = 'text',
	placeholder = '',
	hint = '',
	errorMessage = '',
	validMessage = '',
	style = {},
	...rest
}) => (
	<my.Elemet data-inline={!!inline}
						 data-inline-extended={inlineExtended}
						 data-type={type.toLocaleLowerCase()}
						 className={className}
						 style={style}
	>
		{!!label && (
			<my.Label data-inline={!!inline}
								data-inline-extended={inlineExtended}
								className={labelClassName}
			>
				{label}
			</my.Label>)}
		<my.Input
			{...rest}
			{...(inputRef ? {ref: inputRef} : {})}
			data-disabled={rest.disabled}
			data-inline={!!inline}
			data-inline-extended={inlineExtended}
			data-invalid={!!errorMessage}
			data-valid={!!validMessage}
			name={name}
			placeholder={placeholder}
			type={type}
			className={inputClassName}
		/>
		{!!errorMessage && (<my.Error data-inline={!!inline}>{errorMessage}</my.Error>)}
		{!!validMessage && (<my.Success data-inline={!!inline}>{validMessage}</my.Success>)}
		{
			!!hint && (
				typeof hint === 'string' 
					? <my.Hint data-inline={!!inline} dangerouslySetInnerHTML={{__html: hint}} />
					: <my.Hint data-inline={!!inline}>{hint}</my.Hint>
			)
		}
	</my.Elemet>
)

TextInput.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	name: PropTypes.string,
	type: PropTypes.string,
	placeholder: PropTypes.string,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string
}


export const TextArea = ({
	className = '',
	inputRef = false,
	inline = false,
	label = '',
	labelClassName,
	name = '',
	placeholder = '',
	hint = '',
	errorMessage = '',
	validMessage = '',
	rows = 4,
	...rest
}) => (
	<my.Elemet data-inline={!!inline} className={className}>
		{!!label && (<my.Label data-inline={!!inline} className={labelClassName}>{label}</my.Label>)}
		<my.Textarea
			{...rest}
			{...(inputRef ? {ref: inputRef} : {})}
			className={'scroll'}
			data-inline={!!inline}
			data-invalid={!!errorMessage}
			data-valid={!!validMessage}
			name={name}
			placeholder={placeholder}
			rows={rows}
		>
			{rest.value}
		</my.Textarea>
		{!!errorMessage && (<my.Error data-inline={!!inline}>{errorMessage}</my.Error>)}
		{!!validMessage && (<my.Success data-inline={!!inline}>{validMessage}</my.Success>)}
		{
			!!hint && (
				typeof hint === 'string'
					? <my.Hint data-inline={!!inline} dangerouslySetInnerHTML={{__html: hint}} />
					: <my.Hint data-inline={!!inline}>{hint}</my.Hint>
			)
		}
	</my.Elemet>
)
TextArea.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	name: PropTypes.string,
	placeholder: PropTypes.string,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string,
	rows: PropTypes.number
}
